import { writable } from "svelte/store";

export let profileData = writable();
export let clinicsData = writable();
export let contentShellData = writable();
export let blankClinicData = writable();
export let currentActiveObjectData = writable();
export let menuData = writable();
export let notificationData = writable([]);
export let entityData = writable();